import {
  FocusOnce,
  ModalBody,
  ModalButton,
  ModalFooter,
  ModalHeader,
} from "baseui/modal";
import CircleLoader from "components/atoms/CircleLoader";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { modalActions } from "redux/slices/modal/modalReducer";
import Button from "components/atoms/Button";
import PartnerService from "services/partner.service";

export default function PartnerStatus() {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.partners);
  const { id, status } = useAppSelector((state) => state.modal.data);

  const handleClick = async () => {
    let payload = {
      id: id,
      status: status,
    };
    PartnerService.partnerStatus(payload, dispatch);
  };
  return (
    <div>
      <FocusOnce>
        <ModalHeader>Partner Status</ModalHeader>
      </FocusOnce>
      <ModalBody>
        {loading && <CircleLoader />}
        Are you sure you want make this partner status as {status}?
      </ModalBody>

      <ModalFooter>
        <ModalButton
          size="compact"
          kind="tertiary"
          onClick={() => dispatch(modalActions.closeModal())}
        >
          No
        </ModalButton>
        <Button size="compact" onClick={handleClick}>
          Yes
        </Button>
      </ModalFooter>
    </div>
  );
}
